import { render, staticRenderFns } from "./PromoList.vue?vue&type=template&id=5c77ca32&scoped=true&"
import script from "./PromoList.vue?vue&type=script&lang=js&"
export * from "./PromoList.vue?vue&type=script&lang=js&"
import style0 from "./PromoList.vue?vue&type=style&index=0&id=5c77ca32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c77ca32",
  null
  
)

export default component.exports